import { useEffect, useState } from 'react';

import { useSwimlaneState } from '../../context';
import type { TCardId } from '../../types';

import { useFirstDraggingCardId } from './CardsDNDContext';

export function CardDropIndicator({ cardId }: { cardId: TCardId }) {
  const draggingCardId = useFirstDraggingCardId();
  const { onCardDropIndicatorShown, onCardDropIndicatorHidden, getCardHeight } = useSwimlaneState();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (draggingCardId) {
      onCardDropIndicatorShown(cardId, draggingCardId);
    }
    const rafId = requestAnimationFrame(() => setExpanded(true));
    return () => {
      cancelAnimationFrame(rafId);
      onCardDropIndicatorHidden(cardId);
    };
  }, [cardId, draggingCardId, onCardDropIndicatorShown, onCardDropIndicatorHidden]);

  const height = draggingCardId ? getCardHeight(draggingCardId) : 0;

  return (
    <div
      className="overflow-hidden transition-[max-height] duration-[250ms] ease-in-out"
      style={{ maxHeight: expanded ? height : 0 }}
    >
      <div className="rounded bg-neutral-100" style={{ height }} />
    </div>
  );
}
